"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHAIN_GAS_RECOMMENDATION = exports.defaultConfig = void 0;
var _types_1 = require("../types");
var dts_config_1 = __importDefault(require("./dts.config"));
var factory_config_1 = __importDefault(require("./v0.5/factory.config"));
var factory_config_2 = __importDefault(require("./v0.5.1/factory.config"));
var factory_config_3 = __importDefault(require("./v0.5.2/factory.config"));
var factory_config_4 = __importDefault(require("./v0.6/factory.config"));
exports.defaultConfig = {
    factory: {
        'v0.5': factory_config_1.default,
        'v0.5.1': factory_config_2.default,
        'v0.5.2': factory_config_3.default,
        'v0.6': factory_config_4.default
    },
    decentralizedTrustScore: dts_config_1.default
};
var DEFAULT_GAS_RECOMMENDATION = {
    default: {
        limit: 250000
    },
    checkTest: {
        limit: 400000
    },
    checkTestWithState: {
        limit: 450000
    },
    createPool: {
        limit: 550000
    }
};
// Generate a [key, value] array to generate CHAIN_GAS_RECOMMENDATION constant 
var entries = Object.values(_types_1.Network).map(function (network) {
    return [network, DEFAULT_GAS_RECOMMENDATION];
});
exports.CHAIN_GAS_RECOMMENDATION = Object.fromEntries(entries);
